/**
 * Filtros do Meu Desempenho (preferencias_ui.desempenho_filtros, sync web ↔ mobile).
 * O backend lê a preferência e aplica sozinho em todo pedido do dashboard.
 *
 * { cartoes_ocultos: number[], portadores_ocultos: string[] }
 * Portadores são guardados por nome: a mesma pessoa em dois cartões some dos dois.
 */

export const normalizarNomePortador = (nome) =>
    (nome || '').split(/\s+/).filter(Boolean).join(' ').toLowerCase();

/** @returns {{ cartoes_ocultos: number[], portadores_ocultos: string[] }} */
export function getDesempenhoFiltros(preferenciasUi) {
    const f = preferenciasUi?.desempenho_filtros;
    return {
        cartoes_ocultos: Array.isArray(f?.cartoes_ocultos) ? f.cartoes_ocultos : [],
        portadores_ocultos: Array.isArray(f?.portadores_ocultos) ? f.portadores_ocultos : [],
    };
}

export function contarFiltrosAtivos(filtros) {
    return (filtros?.cartoes_ocultos?.length || 0) + (filtros?.portadores_ocultos?.length || 0);
}

/** Monta preferencias_ui para PATCH; filtros vazios limpam a chave. */
export function buildFiltrosPatch(preferenciasUiAtual, filtros) {
    const base =
        preferenciasUiAtual && typeof preferenciasUiAtual === 'object'
            ? { ...preferenciasUiAtual }
            : {};
    base.desempenho_filtros = contarFiltrosAtivos(filtros) > 0 ? filtros : null;
    return base;
}

/**
 * Agrupa adicionais por pessoa (nome normalizado), com os cartões de cada uma.
 * @returns {{ chave: string, nome: string, cartoes: string[] }[]}
 */
export function agruparPortadores(adicionais, cartoes) {
    const nomeCartao = new Map((cartoes || []).map((c) => [c.id, c.nome]));
    const grupos = new Map();
    (adicionais || []).forEach((a) => {
        const chave = normalizarNomePortador(a.portador);
        if (!chave) return;
        const g = grupos.get(chave) || { chave, nome: a.portador.trim(), cartoes: [] };
        const cartao = nomeCartao.get(a.cartao_principal);
        if (cartao && !g.cartoes.includes(cartao)) g.cartoes.push(cartao);
        grupos.set(chave, g);
    });
    return [...grupos.values()].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
}
